import { Icon } from "@plone/volto/components";
import paintBucketSVG from "@plone/volto/icons/paint.svg";
import heroSVG from "@plone/volto/icons/hero.svg";
import cardsSVG from "@plone/volto/icons/cards.svg";
import iconSVG from "@plone/volto/icons/select-all.svg";
import sliderSVG from "@plone/volto/icons/slider.svg";
import videoSVG from "@plone/volto/icons/video.svg";
import graphSVG from "@plone/volto/icons/slider.svg";
import printerSVG from "@plone/volto/icons/printer.svg";
import linkSVG from "@plone/volto/icons/link.svg";
import {
  Edit as CustomHeroEdit,
  View as CustomHeroView,
} from "./components/Blocks/CustomHero";
import {
  Edit as ButtonRowEdit,
  View as ButtonRowView,
} from "./components/Blocks/ButtonRow";
import {
  Edit as MultiCardEdit,
  View as MultiCardView,
} from "./components/Blocks/MultiCardBlock";
import {
  Edit as IconLinkRowEdit,
  View as IconLinkRowView,
} from "./components/Blocks/IconLinkRow";
import {
  Edit as EmblaCarouselEdit,
  View as EmblaCarouselView,
} from "./components/Blocks/EmblaCarousel";
import {
  Edit as MediaPlayerEdit,
  View as MediaPlayerView,
} from "./components/Blocks/MediaPlayer";
import {
  Edit as EmblaRatingsEdit,
  View as EmblaRatingsView,
} from "./components/Blocks/EmblaRatings";
import {
  Edit as GraphBlockEdit,
  View as GraphBlockView,
} from "./components/Blocks/GraphBlock";
import LeftColumnFacets from "./customizations/components/manage/Blocks/Search/layout/LeftColumnFacets";
import RightColumnFacets from "./customizations/components/manage/Blocks/Search/layout/RightColumnFacets";
import TopSideFacets from "./customizations/components/manage/Blocks/Search/layout/TopSideFacets";
import AuthBanner from "./components/theme/AuthBanner";
import IPLoginHandler from "./components/theme/IPLoginHandler";
import ipAuthReducer from "./reducers/ipAuth";
import {
  Edit as PrintReportEdit,
  View as PrintReportView,
} from "./components/Blocks/PrintReport";
import {
  Edit as RedirectEdit,
  View as RedirectView,
} from "./components/Blocks/Redirect";

//social sharing button
//import SocialSharing from '@codesyntax/volto-social-sharing/SocialSharing';
//import { DEFAULT_SOCIAL } from '@codesyntax/volto-social-sharing/defaultSettings';
//change twitter to X

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ["en"];
  config.settings.defaultLanguage = "en";

  //Make lead image block available everywhere
  config.blocks.blocksConfig.leadimage.restricted = false;

  config.blocks.themes = [
    {
      style: {
        "--theme-color": "white",
        "--theme-high-contrast-color": "var(--blue)",
        "--theme-foreground-color": "var(--charcoal)",
        "--theme-low-contrast-foreground-color": "var(--lightblue)",
        "--link-foreground-color": "var(--blue)",
      },
      name: "default",
      label: "Default",
    },
    {
      style: {
        "--theme-color": "var(--lightgrey)",
        "--theme-high-contrast-color": "var(--charcoal)",
        "--theme-foreground-color": "var(--charcoal)",
        "--theme-low-contrast-foreground-color": "var(--charcoal)",
        "--link-foreground-color": "var(--blue)",
      },
      name: "lightgrey",
      label: "Light Grey",
    },
    {
      style: {
        "--theme-color": "var(--red)",
        "--theme-high-contrast-color": "white",
        "--theme-foreground-color": "white",
        "--theme-low-contrast-foreground-color": "white",
        "--link-foreground-color": "white",
      },
      name: "red",
      label: "Red",
    },
    {
      style: {
        "--theme-color": "var(--deeporange)",
        "--theme-high-contrast-color": "white",
        "--theme-foreground-color": "white",
        "--theme-low-contrast-foreground-color": "white",
        "--link-foreground-color": "white",
      },
      name: "deeporange",
      label: "Deep Orange",
    },
    {
      style: {
        "--theme-color": "var(--charcoal)",
        "--theme-high-contrast-color": "white",
        "--theme-foreground-color": "white",
        "--theme-low-contrast-foreground-color": "white",
        "--link-foreground-color": "white",
      },
      name: "charcoal",
      label: "Charcoal",
    },
  ];

  //Enable autoplay on Slider
  config.blocks.blocksConfig.slider.enableAutoPlay = true;

  //Adding custom colours and block styles to Slate editor
  config.settings.slate.styleMenu.inlineStyles = [
    ...(config.settings.slate.styleMenu?.inlineStyles || []),
    {
      cssClass: "text-red",
      label: "Red Text",
      icon: () => <Icon name={paintBucketSVG} size="18px" color="red" />,
    },
    {
      cssClass: "text-red-bold",
      label: "Bold Red Text",
      icon: () => <Icon name={paintBucketSVG} size="18px" color="red" />,
    },
  ];
  config.settings.slate.styleMenu.blockStyles = [
    ...(config.settings.slate.styleMenu?.blockStyles || []),
    {
      cssClass: "highlight-block",
      label: "Highlighted Block",
      nodeType: "paragraph",
      icon: () => (
        <div
          style={{
            backgroundColor: "--red",
            width: "18px",
            height: "18px",
            borderRadius: "3px",
          }}
        />
      ),
    },
  ];

  //CustomHero
  config.blocks.blocksConfig.customHero = {
    id: "customHero",
    title: "Hero Block",
    icon: heroSVG,
    group: "common",
    view: CustomHeroView,
    edit: CustomHeroEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //ButtonRow
  config.blocks.blocksConfig.buttonRow = {
    id: "buttonRow",
    title: "Button Row",
    icon: cardsSVG,
    group: "common",
    view: ButtonRowView,
    edit: ButtonRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //add in social sharing block
  /*config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: SocialSharing,
      props: {
        socialElements: DEFAULT_SOCIAL,
      },
    },
  ];*/

  //IconLinkRow
  config.blocks.blocksConfig.iconLinkRow = {
    id: "iconLinkRow",
    title: "Icon Link Row",
    icon: iconSVG,
    group: "common",
    view: IconLinkRowView,
    edit: IconLinkRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    carousel: {
      autoplay: true,
      delay: 8000,
    },
  };

  //Multicard Block
  config.blocks.blocksConfig.multiCard = {
    id: "multiCard",
    title: "Multi Card",
    icon: cardsSVG,
    group: "common",
    view: MultiCardView,
    edit: MultiCardEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Embla Carousel
  config.blocks.blocksConfig.EmblaCarousel = {
    id: "EmblaCarousel",
    title: "Embla Carousel",
    icon: sliderSVG,
    group: "common",
    view: EmblaCarouselView,
    edit: EmblaCarouselEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.graphBlock = {
    id: "graphBlock",
    title: "Graph Block",
    icon: graphSVG,
    group: "common",
    view: GraphBlockView,
    edit: GraphBlockEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.MediaPlayer = {
    id: "MediaPlayer",
    title: "Media Player",
    icon: videoSVG,
    group: "media",
    view: MediaPlayerView,
    edit: MediaPlayerEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.EmblaRatings = {
    id: "EmblaRatings",
    title: "Embla Ratings",
    icon: sliderSVG,
    group: "common",
    view: EmblaRatingsView,
    edit: EmblaRatingsEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Auth Banner
  config.settings.authBanner = {
    loginPath: "/login",
    registerPath: "/subscribe",
    postLogoutPath: "/",
  };

  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: "", // all routes
      component: AuthBanner,
    },
    {
      match: "",
      component: IPLoginHandler,
    },
  ];

  // Remove the Volto Light Theme's schema enhancer
  delete config.blocks.blocksConfig.search.schemaEnhancer;

  // Restore the original search block variations
  config.blocks.blocksConfig.search.variations = [
    {
      id: "facetsTopSide",
      title: "Facets on top",
      view: TopSideFacets,
      isDefault: true,
    },
    {
      id: "facetsLeftSide",
      title: "Facets on left",
      view: LeftColumnFacets,
    },
    {
      id: "facetsRightSide",
      title: "Facets on right",
      view: RightColumnFacets,
    },
  ];

  //Print Report
  config.blocks.blocksConfig.printReport = {
    id: "printReport",
    title: "Print Report",
    icon: printerSVG,
    group: "common",
    view: PrintReportView,
    edit: PrintReportEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 0,
    printConfig: {
      printContainer: "#page-document", // adjust to match your actual container selector
      excludeBlocks: [
        "printReport",
        "EmblaCarousel",
        "MediaPlayer",
        // add others as needed
      ],
    },
  };

  //Redirect block
  config.blocks.blocksConfig.redirectBlock = {
    id: "redirectBlock",
    title: "Redirect",
    icon: linkSVG,
    group: "common",
    view: RedirectView,
    edit: RedirectEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 0,
    security: {
      addPermission: [],
      view: [],
    },
  };

  //register reducers
  config.addonReducers = config.addonReducers || {};
  config.addonReducers.ipAuth = ipAuthReducer;

  return config;
};

export default applyConfig;
